import React from 'react';

import glassImages from '../../../data/glassImages.js';

const imageSizes = ['original', 900, 700, 500, 450, 350, 250, 160, 80];

export default ({ itemId, imageId, sizes, sizeOverride, alt = '' }) => (
  <img
    alt={alt}
    srcSet={
      sizeOverride
        ? null
        : imageSizes
            .slice(1)
            .map(size => `${glassImages[itemId][imageId][size]} ${size}w`)
            .join(',\n')
    }
    sizes={sizes}
    src={
      sizeOverride
        ? glassImages[itemId][imageId][sizeOverride]
        : glassImages[itemId][imageId].original
    }
  />
);



// WEBPACK FOOTER //
// ./src/components/item-image/index.js